export default "__VITE_ASSET__0504e58f__"